import React from 'react';
import enma from '../../assets/images/sponsors/enma.png';
import jazeera from '../../assets/images/sponsors/jazeera.png';
import ahli from '../../assets/images/sponsors/ahli.svg';
import khaleej from '../../assets/images/sponsors/khaleej.png';
import riyadh from '../../assets/images/sponsors/riyadh.png';
import rajhi from '../../assets/images/sponsors/rajhi.png';
import arabi from '../../assets/images/sponsors/arabi.png';
import samba from '../../assets/images/sponsors/samba.png';
import french from '../../assets/images/sponsors/french.png';
import invest from '../../assets/images/sponsors/invest.png';
import sabb from '../../assets/images/sponsors/sabb.png';
import bilad from '../../assets/images/sponsors/bilad.png';
import { useTranslation } from 'react-i18next';
function Sponsors() {
    const { t, i18n } = useTranslation();
    return (
        <div className='sponsors mx-auto col'>
            <h1>{t('who.partners')}</h1>
            <div className='mx-auto row sponsors-imgs'>
                <img src={samba} alt='sponsor' />
                <img src={arabi} alt='sponsor' />
                <img src={riyadh} alt='sponsor' />
                <img src={enma} alt='sponsor' />
                <img src={rajhi} alt='sponsor' />
                <img src={khaleej} alt='sponsor' />
                <img src={ahli} alt='sponsor' />
                <img src={jazeera} alt='sponsor' />
                <img src={french} alt='sponsor' />
                <img src={invest} alt='sponsor' />
                <img src={sabb} alt='sponsor' />
                <img src={bilad} alt='sponsor' />
            </div>
        </div>
    );
}

export default Sponsors;
